__turbopack_context__.v({
  "className": "ibm_plex_mono_b9258b68-module__BQCR3W__className",
  "variable": "ibm_plex_mono_b9258b68-module__BQCR3W__variable",
});
